import {Modes} from '../modes.js';

const ModeSelector = ({selectedMode, onSelected}) => {
    return (
        <div>
            <p>Выберите режим:</p>
            <ul>
                <li style={selectedMode === Modes.COMFORTABLEENVIRONMENT.color ? {fontWeight: "bold"} : {}} onClick={() => onSelected && onSelected(Modes.COMFORTABLEENVIRONMENT.color)}><span style={{color: Modes.COMFORTABLEENVIRONMENT.color}}>▉</span> {Modes.COMFORTABLEENVIRONMENT.text}</li>
                <li style={selectedMode === Modes.AGRESSIVEFIELD.color ? {fontWeight: "bold"} : {}} onClick={() => onSelected && onSelected(Modes.AGRESSIVEFIELD.color)}><span style={{color: Modes.AGRESSIVEFIELD.color}}>▉</span> {Modes.AGRESSIVEFIELD.text}</li>
                <li style={selectedMode === Modes.HOMOGENEOUSFIELD.color ? {fontWeight: "bold"} : {}} onClick={() => onSelected && onSelected(Modes.HOMOGENEOUSFIELD.color)}><span style={{color: Modes.HOMOGENEOUSFIELD.color}}>▉</span> {Modes.HOMOGENEOUSFIELD.text}</li>
                <li style={selectedMode === Modes.VISUALNOISE.color ? {fontWeight: "bold"} : {}} onClick={() => onSelected && onSelected(Modes.VISUALNOISE.color)}><span style={{color: Modes.VISUALNOISE.color}}>▉</span> {Modes.VISUALNOISE.text}</li>
            </ul>
        </div>
    );
}

export {ModeSelector};